import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useRef, useState, useMemo, useImperativeHandle, forwardRef } from 'react';
import { JukeboxProvider, FullWidthContainer, Box, Loader } from '@xceedsrl/jukebox';
import { getDefaultPaymentConfig } from '../config/constants';
import { convertBookingData } from '../utils/forms';
import { DiciottoApp } from '../components/DiciottoApp';
import AdyenCheckout from '@adyen/adyen-web';
import { getSession, confirmBooking, confirmPaymentResult, updateBooking } from './XceedClient';
import adyenStyles from '@adyen/adyen-web/dist/adyen.css';
import styled from 'styled-components';
var AdyenContainer = styled.div.withConfig({
  displayName: "PaymentForm__AdyenContainer",
  componentId: "sc-p1n9wi-0"
})(["", " .adyen-checkout__payment-method--selected{background-color:white;}.adyen-checkout__payment-method:last-child{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}"], adyenStyles, function (props) {
  return props.is18appEnabled && !props.isDiciottoAppSelected ? 0 : "12px";
}, function (props) {
  return props.is18appEnabled && !props.isDiciottoAppSelected ? 0 : "12px";
});
var SpinnerContainer = styled.div.withConfig({
  displayName: "PaymentForm__SpinnerContainer",
  componentId: "sc-p1n9wi-1"
})([".spinner-container{display:flex;align-items:center;width:100%;justify-content:center;}"]);
var PaymentForm = forwardRef(function (_ref, ref) {
  var lang = _ref.lang,
    bookingData = _ref.bookingData,
    onSuccess = _ref.onSuccess,
    onFailure = _ref.onFailure,
    onFailureLogging = _ref.onFailureLogging,
    onPending = _ref.onPending,
    onValidate = _ref.onValidate,
    participants = _ref.participants,
    is18appEnabled = _ref.is18appEnabled,
    currency = _ref.currency,
    amount = _ref.amount,
    country = _ref.country,
    apiHost = _ref.apiHost,
    locale = _ref.locale,
    config = _ref.config,
    paymentAccountId = _ref.paymentAccountId,
    enableStoreDetails = _ref.enableStoreDetails,
    authToken = _ref.authToken,
    setAdyenCheckout = _ref.setAdyenCheckout,
    app18voucher = _ref.app18voucher,
    setApp18voucher = _ref.setApp18voucher,
    googlePayConfiguration = _ref.googlePayConfiguration;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    dropinComponent = _useState2[0],
    setDropinComponent = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showSpinner = _useState4[0],
    setShowSpinner = _useState4[1];
  var adyenRef = useRef();
  var _useState5 = useState(is18appEnabled),
    _useState6 = _slicedToArray(_useState5, 2),
    isDiciottoAppSelected = _useState6[0],
    setIsDiciottoAppSelected = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    isCarteCulturaSelected = _useState8[0],
    setIsCarteCulturaSelected = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isAdyenReady = _useState10[0],
    setIsAdyenReady = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    diciottoAppVoucherCode = _useState12[0],
    setDiciottoAppVoucherCode = _useState12[1];
  if (!participants) {
    onFailure({
      success: 'reloadPaymentErrorDescription'
    });
    return null;
  }
  useEffect(function () {
    if (dropinComponent) setAdyenCheckout(dropinComponent);
  }, [dropinComponent]);
  var fetchData = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(configuration) {
      var checkout;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return AdyenCheckout(configuration);
          case 2:
            checkout = _context.sent;
            if (adyenRef.current) setDropinComponent(checkout.create('dropin', {
              openFirstPaymentMethod: true,
              openFirstStoredPaymentMethod: true,
              onSelect: function onSelect(component) {
                var _component$state;
                onValidate(!!(component !== null && component !== void 0 && (_component$state = component.state) !== null && _component$state !== void 0 && _component$state.isValid));
                setIsDiciottoAppSelected(false);
                setIsCarteCulturaSelected(false);
              },
              onReady: function onReady() {
                setIsAdyenReady(true);
              }
            }).mount(adyenRef.current));
            setShowSpinner(false);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var paymentConfig = useMemo(getDefaultPaymentConfig, []);
  var submit = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(additionalBookingData) {
      var bookingParticipants, purchaseInfo, bookingId;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            bookingParticipants = convertBookingData(participants);
            purchaseInfo = {
              paymentConfig: paymentConfig,
              onFailure: onFailure,
              onSuccess: onSuccess,
              onPending: onPending,
              bookingData: _objectSpread(_objectSpread(_objectSpread({}, bookingData), bookingParticipants), additionalBookingData)
            };
            if (!(isDiciottoAppSelected || isCarteCulturaSelected)) {
              _context2.next = 5;
              break;
            }
            submit18App(_objectSpread(_objectSpread({}, purchaseInfo.bookingData), {}, {
              paymentPlatform: isDiciottoAppSelected ? 'app18' : 'carte_cultura'
            }));
            return _context2.abrupt("return");
          case 5:
            _context2.prev = 5;
            if (!additionalBookingData) {
              _context2.next = 12;
              break;
            }
            _context2.next = 9;
            return updateBooking(apiHost, bookingData.bookingId, additionalBookingData, authToken);
          case 9:
            bookingId = _context2.sent;
            if (bookingId) {
              _context2.next = 12;
              break;
            }
            throw new Error('Impossible to pay!');
          case 12:
            dropinComponent.submit();
            _context2.next = 18;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](5);
            onFailure(_context2.t0);
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[5, 15]]);
    }));
    return function submit(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleDiciottoAppSelected = function handleDiciottoAppSelected() {
    if (!isDiciottoAppSelected) {
      dropinComponent.closeActivePaymentMethod();
      setIsDiciottoAppSelected(true);
      setIsCarteCulturaSelected(false);
      setDiciottoAppVoucherCode('');
    }
  };
  var handleCarteCulturaAppSelected = function handleCarteCulturaAppSelected() {
    if (!isCarteCulturaSelected) {
      dropinComponent.closeActivePaymentMethod();
      setIsCarteCulturaSelected(true);
      setIsDiciottoAppSelected(false);
      setDiciottoAppVoucherCode('');
    }
  };
  var handleDiciottoAppChange = function handleDiciottoAppChange(e) {
    var value = e.target.value;
    onValidate(value.length > 0);
    setApp18voucher(value);
    setDiciottoAppVoucherCode(value);
  };
  var unselectDiciottoApp = function unselectDiciottoApp() {
    setIsDiciottoAppSelected(false);
    setIsCarteCulturaSelected(false);
  };
  useImperativeHandle(ref, function () {
    return {
      submit: submit,
      unselectDiciottoApp: unselectDiciottoApp
    };
  });
  useEffect(function () {
    var params = new URLSearchParams(window.location.search);
    var sessionId = params.get('sessionId');
    var redirectResult = params.get('redirectResult');
    if (bookingData.bookingId && !sessionId && !redirectResult) {
      _asyncToGenerator(_regeneratorRuntime.mark(function _callee4() {
        var adyenSession, _yield$adyenSession$j, session, configuration;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getSession(bookingData.bookingId, currency, amount, country, participants, bookingData, paymentAccountId, config.checkoutHost);
            case 2:
              adyenSession = _context4.sent;
              _context4.next = 5;
              return adyenSession.json();
            case 5:
              _yield$adyenSession$j = _context4.sent;
              session = _yield$adyenSession$j.data;
              configuration = {
                environment: config.environment,
                clientKey: config.clientKey,
                locale: locale,
                session: session,
                onPaymentCompleted: function onPaymentCompleted(result, component) {
                  onSuccess(result, bookingData.bookingId);
                },
                onError: function onError(error, component) {
                  onFailureLogging(error);
                },
                onChange: function onChange(state) {
                  onValidate(state.isValid);
                },
                onAdditionalDetails: function () {
                  var _onAdditionalDetails = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(state, component) {
                    var _result$data, result, _result$data2;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(state !== null && state !== void 0 && state.data)) {
                            _context3.next = 5;
                            break;
                          }
                          _context3.next = 3;
                          return confirmPaymentResult(config.checkoutHost, session.paymentId, state.data, authToken);
                        case 3:
                          result = _context3.sent;
                          if ((result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.status) === 'accepted') {
                            onSuccess({
                              resultCode: result.data.status
                            }, bookingData.bookingId);
                          } else {
                            onFailure({
                              message: result === null || result === void 0 || (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.errorReason
                            });
                          }
                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  function onAdditionalDetails(_x3, _x4) {
                    return _onAdditionalDetails.apply(this, arguments);
                  }
                  return onAdditionalDetails;
                }(),
                showPayButton: false,
                paymentMethodsConfiguration: {
                  bcmc: {
                    enableStoreDetails: enableStoreDetails
                  },
                  card: {
                    hasHolderName: true,
                    holderNameRequired: true,
                    enableStoreDetails: enableStoreDetails
                  },
                  applepay: {
                    showPayButton: true
                  },
                  googlepay: {
                    showPayButton: true,
                    configuration: googlePayConfiguration
                  },
                  paypal: {
                    showPayButton: true
                  }
                }
              };
              if (session !== null && session !== void 0 && session.id) {
                fetchData(configuration)["catch"](function (error) {
                  onFailure(error);
                });
              }
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }, [bookingData === null || bookingData === void 0 ? void 0 : bookingData.bookingId]);
  function submit18App(_x5) {
    return _submit18App.apply(this, arguments);
  }
  function _submit18App() {
    _submit18App = _asyncToGenerator(_regeneratorRuntime.mark(function _callee5(bookingData) {
      var endPending, bookingId;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return onPending();
          case 3:
            endPending = _context5.sent;
            bookingId = null;
            _context5.prev = 5;
            _context5.next = 8;
            return confirmBooking(bookingData.bookingId, bookingData, apiHost, lang, authToken);
          case 8:
            bookingId = _context5.sent;
            _context5.next = 14;
            break;
          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](5);
            throw new Error(_context5.t0);
          case 14:
            if (!(typeof endPending === 'function')) {
              _context5.next = 17;
              break;
            }
            _context5.next = 17;
            return endPending(bookingId);
          case 17:
            if (!bookingId) {
              _context5.next = 21;
              break;
            }
            onSuccess({
              resultCode: 'Authorised'
            }, bookingId);
            _context5.next = 22;
            break;
          case 21:
            throw new Error('Impossible to pay!');
          case 22:
            _context5.next = 27;
            break;
          case 24:
            _context5.prev = 24;
            _context5.t1 = _context5["catch"](0);
            onFailure(_context5.t1);
          case 27:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 24], [5, 11]]);
    }));
    return _submit18App.apply(this, arguments);
  }
  return React.createElement(JukeboxProvider, null, React.createElement(FullWidthContainer, {
    id: "xceed-dropin-container"
  }, React.createElement(Box, {
    position: "relative"
  }, React.createElement(AdyenContainer, {
    is18appEnabled: is18appEnabled,
    isDiciottoAppSelected: isDiciottoAppSelected,
    id: "dropin-container",
    ref: adyenRef
  }), is18appEnabled && isAdyenReady && React.createElement(React.Fragment, null, React.createElement(DiciottoApp, {
    isDiciottoAppSelected: isDiciottoAppSelected,
    isCarteCulturaSelected: isCarteCulturaSelected,
    value: diciottoAppVoucherCode,
    handleClick: handleDiciottoAppSelected,
    onChange: handleDiciottoAppChange,
    isDiciottoAppInput: true
  }), React.createElement(DiciottoApp, {
    isDiciottoAppSelected: isDiciottoAppSelected,
    isCarteCulturaSelected: isCarteCulturaSelected,
    value: diciottoAppVoucherCode,
    handleClick: handleCarteCulturaAppSelected,
    onChange: handleDiciottoAppChange,
    isDiciottoAppInput: false
  })), showSpinner && React.createElement(SpinnerContainer, null, React.createElement(Box, {
    className: "spinner-container"
  }, React.createElement(Loader, {
    size: 200
  }))))));
});
PaymentForm.defaultProps = {
  lang: 'en',
  locale: 'en_GB',
  initialValues: {},
  buyerFields: [],
  holderFields: [],
  onSuccess: function onSuccess() {},
  onFailure: function onFailure() {},
  onPending: function onPending() {},
  onValidate: function onValidate() {},
  is18appEnabled: false,
  authToken: ''
};
PaymentForm.displayName = 'PaymentForm';
export default PaymentForm;